import { isNil } from 'ramda';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledDatePicker } from '../../../../../shared';

const ValidFromAndToSection = () => {
  const { control, getValues } = useFormContext();
  const { t } = useTranslation('common');

  const isStart = !isNil(getValues('start'));
  const isEnd = !isNil(getValues('end'));

  return (
    <>
      <ControlledDatePicker
        required
        fullWidth
        variant="outlined"
        control={control}
        name={isStart ? 'start' : 'valid_from'}
        label={t('validFrom')}
      />
      <ControlledDatePicker
        required
        fullWidth
        variant="outlined"
        control={control}
        name={isEnd ? 'end' : 'valid_to'}
        label={t('validTo')}
      />
    </>
  );
};

export default ValidFromAndToSection;
